export { default } from "./AppointmentRequestsByCustomerNumber.component";
